import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@material-ui/core/Typography';
/** The `DescriptionField` is the template to use to render the description of a field
 *
 * @param props - The `DescriptionFieldProps` for this component
 */
export default function DescriptionField(props) {
    const { id, description } = props;
    if (description) {
        return (_jsx(Typography, Object.assign({ id: id, variant: 'subtitle2', style: { marginTop: '5px' } }, { children: description })));
    }
    return null;
}
//# sourceMappingURL=DescriptionField.js.map